import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  customProperties: true,
  theme: {
    dark: false, // will be light on exterior, but toggleable after auth
    themes: {
      light: {
        primary: '#082543',  // colors.blueGrey.darken2,
        secondary: colors.green.accent4,
        accent: colors.green.accent4,
        error: colors.deepOrange.darken3,
        warning: colors.orange.base,
        info: colors.blueGrey.lighten1,
        success: colors.green.accent4
      },
      dark: {
        primary: '#8abcf1', // '#41b554',  // colors.blueGrey.darken2, - https://pinetools.com/lighten-color (90)
        secondary: colors.green, // colors.green.accent4,
        accent: colors.green,
        error: colors.deepOrange.darken3,
        warning: colors.orange.base,
        info: colors.blueGrey.lighten1,
        success: colors.green
      }
    }
  }
});
